// extracted by mini-css-extract-plugin
module.exports = {"list-item-box":"_23rY2hjcUCHoXiaNjQSV2W","sales-type-title":"_39F5_29VYGUNjC3V8JiSE0"};